// Hybec Air — product-card colour swatches: clicking a swatch highlights it
// and swaps the card's primary photo to that colour's variant image.
// Delegated on document so it works for every card, including ones added
// later (recommendations load in via fetch). Guarded so re-inclusion of the
// <script> tag on every card instance is a no-op after the first run.
(function () {
  if (window.__hyCardSwatchesInit) return;
  window.__hyCardSwatchesInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hy-swatch-dot');
    if (!btn) return;

    var list = btn.closest('.hy-card-swatch-list');
    if (list) {
      list.querySelectorAll('.hy-swatch-dot').forEach(function (dot) {
        dot.classList.remove('is-active');
      });
    }
    btn.classList.add('is-active');

    var card = btn.closest('.product-card');
    if (!card) return;

    // Keep the card's Add to Cart button in sync with the selected colour,
    // regardless of whether an image match was found for it.
    var variantId = btn.getAttribute('data-variant-id');
    if (variantId) {
      var variantInput = card.querySelector('.hy-card-atc-variant-input');
      if (variantInput) variantInput.value = variantId;
    }

    // Price can differ by colour — rebuild the price row from this
    // swatch's own price/MRP/%-off (set in snippets/hybec-color-swatch.liquid)
    // rather than only patching individual spans, since a colour with no
    // discount may need the MRP/%-off spans removed entirely, and vice versa.
    var price = btn.getAttribute('data-price');
    if (price) {
      var priceRow = card.querySelector('.hy-card-price-row');
      if (priceRow) {
        var mrp = btn.getAttribute('data-mrp');
        var off = btn.getAttribute('data-off');
        var html = '<span class="hy-card-price">' + price + '</span>';
        if (mrp) {
          html += '<span class="hy-card-mrp">MRP: <s>' + mrp + '</s></span>';
        }
        if (off) {
          html += '<span class="hy-card-off">' + off + '% OFF</span>';
        }
        priceRow.innerHTML = html;
      }
    }

    var imageUrl = btn.getAttribute('data-swatch-image');
    if (!imageUrl) return;

    var gallery = card.querySelector('.card-gallery');
    if (!gallery) return;

    var img = gallery.querySelector('img.product-media__image');
    if (img) {
      img.src = imageUrl;
      img.removeAttribute('srcset');
    }

    var scroller = gallery.querySelector('scrollable-component, [data-scroller]') || gallery;
    if (scroller && typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ left: 0 });
    } else {
      scroller.scrollLeft = 0;
    }
  });
})();
